import * as angular from "angular";
import * as $ from "jquery";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .directive('bringozResizer', resizer);

function resizer($compile, $document, $window) {
  return {
    restrict: 'A',
    link: (scope, elem, attr) => {

      elem.on('mouseover', function (event) {
        elem.css({
          // cursor: 'n-resize'
        });
      });

      elem.on('mousedown', function (event) {
        event.preventDefault();

        $document.on('mousemove', mousemove);
        $document.on('mouseup', mouseup);
      });

      $window.addEventListener('mouseup', mouseup, {passive: true});

      function mousemove(event) {

        if (attr.bringozResizer === 'vertical') {
          const parentRect = elem.parent()[0].getBoundingClientRect();
          const x = event.clientX - parentRect.left;

          elem.css({
            left: x + 'px'
          });

          $(attr.bringozResizerLeftId).css({
            width: x + 'px'
          });
          $(attr.bringozResizerRightId).css({
            left: (x + parseInt(attr.bringozResizerWidth)) + 'px'
          });

        }

        if (attr.bringozResizer === 'horizontal') {
          // Horizontal resizer
          var y = window.innerHeight - event.pageY;

          if (y > attr.bringozResizerHeight && y > _.get(attr, 'bringozResizerBottomMinHeight', 0)) {
            $(attr.bringozResizerTopId).css({
              height: (y + parseInt(attr.bringozResizerHeight)) + 'px'
            });
            $(attr.bringozResizerBottomId).css({
              height: y + 'px'
            });
          }
        }
      }

      function mouseup() {
        $document.unbind('mousemove', mousemove);
        $document.unbind('mouseup', mouseup);
      }
    }
  };
}

